import { IAttendee } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IELTHPContact } from 'legacy/lut/classes/models/partner360/ELT/IELTHPContact'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'
import { getHpUsersCrud } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/cruds'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Input } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'

interface IProps {
  onChange: (field: string, index: number) => (value: string) => void
}
export const getHpAttendeesColumns = ({ onChange }: IProps): IColumn<IAttendee>[] => {
  const crud = getHpUsersCrud()
  return [
    {
      title: getFormedEltTranslation('attendees-table-email'),
      field: 'Email',
      renderComponent: ({ value, index }) => (
        <DropdownAutocomplete<IELTHPContact>
          onChange={onChange('Email', index)}
          value={value || ''}
          fieldsToSearch={['Email', 'FullName']}
          calculateCaption={(item: IObjectAny) =>
            `${item.FirstName || ''} ${item.LastName || ''} <${item.Email}>`
          }
          source={crud}
          validateName="Email"
          mode="combobox"
          onItemChange={(value) => {
            onChange('Name', index)(`${value.FirstName} ${value.LastName}`)
            onChange('Title', index)(value.Roles || '')
          }}
          translation="jbp-hpcontactinfo-email-required"
        />
      ),
    },
    {
      title: getFormedEltTranslation('attendees-table-name'),
      field: 'Name',
      renderComponent: ({ value, index }) => (
        <Input value={value || ''} onChange={onChange('Name', index)} />
      ),
    },
    {
      title: getFormedEltTranslation('attendees-table-title'),
      field: 'Title',
      renderComponent: ({ value, index }) => (
        <Input value={value || ''} onChange={onChange('Title', index)} />
      ),
    },
  ]
}
